import { Chip, Tooltip } from '@mui/material'
import {
  CheckCircleOutline,
  ErrorOutline,
  HourglassEmpty,
  Schedule,
  CloudOff,
} from '@mui/icons-material'

 export type DmpSubmissionStatus =
  | 'APPROVED'
  | 'DEPRECATED'
  | 'SUBMITTED'
  | 'ARCHIVED'
  | 'DELETED'
  // | 'FAILED'
  | 'none'

interface DmpStatusIndicatorProps {
  status: DmpSubmissionStatus
  errorMessage?: string | null
  submittedAt?: Date | string | null
  size?: 'small' | 'medium'
}

const STATUS_CONFIG: Record<
  DmpSubmissionStatus,
  {
    label: string
    color: 'default' | 'success' | 'error' | 'warning' | 'info'
    icon: React.ReactElement
    tooltip: string
  }
> = {
  APPROVED: {
    label: 'DMP approuvé',
    color: 'success',
    icon: <CheckCircleOutline fontSize="small" />,
    tooltip: 'Document approuvé et transmis au DMP',
  },
  SUBMITTED: {
    label: 'DMP soumis',
    color: 'info',
    icon: <HourglassEmpty fontSize="small" />,
    tooltip: 'Document soumis au DMP, en attente de validation',
  },
  DEPRECATED: {
    label: 'DMP obsolète',
    color: 'warning',
    icon: <Schedule fontSize="small" />,
    tooltip: 'Document obsolète, remplacé par une version plus récente',
  },
  ARCHIVED: {
    label: 'DMP archivé',
    color: 'default',
    icon: <Schedule fontSize="small" />,
    tooltip: 'Document archivé dans le DMP',
  },
  DELETED: {
    label: 'DMP supprimé',
    color: 'error',
    icon: <ErrorOutline fontSize="small" />,
    tooltip: 'Document supprimé du DMP',
  },
  // FAILED: {
  //   label: 'DMP FAILED',
  //   color: 'error',
  //   icon: <ErrorOutline fontSize="small" />,
  //   tooltip: 'Document FAILED du DMP',
  // },
  none: {
    label: 'DMP non envoyé',
    color: 'default',
    icon: <CloudOff fontSize="small" />,
    tooltip: 'Aucune soumission DMP pour ce document',
  },
}

export const DmpStatusIndicator: React.FC<DmpStatusIndicatorProps> = ({
  status,
  errorMessage,
  submittedAt,
  size = 'small',
}) => {

  console.log(status)
  const config = STATUS_CONFIG[status]

  const tooltipContent = [
    config.tooltip,
    submittedAt && `Le ${new Date(submittedAt).toLocaleString('fr-FR')}`,
    // status === 'FAILED' && errorMessage && `Erreur : ${errorMessage}`,
  ]
    .filter(Boolean)
    .join(' — ')

  return (
    <Tooltip title={tooltipContent} arrow>
      <Chip
        icon={config.icon}
        label={config.label}
        color={config.color}
        size={size}
        variant={status === 'none' ? 'outlined' : 'filled'}
      />
    </Tooltip>
  )
}
